<template>
  <div class="brands">
    <div class="title">
      <custom-breadcrumb />
    </div>
    <div class="brands-search">
      <el-form :inline="true" :model="brandsForm">
        <el-form-item>
          <el-select placeholder="Brand Ownership" v-model="brandsForm.brandOwnerShip" clearable @change="search">
             <el-option
            v-for="(item,index) in drop.ownerShip"
            :key="index"
            :label="item.name"
            :value="item.value"
            />
        </el-select>
        </el-form-item>
        <el-form-item >
          <el-select placeholder="Shipping Fee" v-model="brandsForm.shippingFree" clearable @change="search">
            <el-option
            v-for="(item,index) in drop.shoppingFee"
            :key="index"
            :label="item.name"
            :value="item.value"
            />
        </el-select>
        </el-form-item>
        <el-form-item>
          <el-select placeholder="Status" v-model="brandsForm.brandStatus" clearable @change="search">
            <el-option
            v-for="(item,index) in drop.status"
            :key="index"
            :label="item.name"
            :value="item.value"
            />
        </el-select>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="Brands Name" v-model="brandsForm.keyWords" class="input-with-select" style="width: 505px;">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
          <div class="brands-search-button" slot="append" @click="search">
            Search
          </div>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="brands-content">
      <el-table
       :data="tableData"
       stripe
       style="width: 100%"
      >
        <el-table-column label="Brand Name" min-width="200" fixed width="280">
          <template slot-scope="scope">
            <div class="table-brand">
              <div class="table-brand-img">
                <img :src="scope.row.banner" alt="">
              </div>
              <div class="table-brand-text">
                <div>{{scope.row.brandName}}</div>
                <div style="display: flex;align-items: center">
                  {{scope.row.id}}
                  <i class="el-icon-copy-document copy-text" style="color:#84C5F9;margin-left: 2px;" @click="copy($event,scope.row.id)"></i>
                  </div>
                <div>
                     {{scope.row.companyName}}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="Products" fixed
          >
          <template slot-scope="scope">
            <span style="color:#007AFF">
              {{scope.row.productNum}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
            label="Founded Time"
            prop="foundedTime"
            width="120"
          >
        </el-table-column>
        <el-table-column
            label="Shipping Fee"
            width="120"
          >
          <template slot-scope="scope">
            {{scope.row.shippingFree==1?'free shipping':'non free'}}
          </template>
        </el-table-column>
        <el-table-column
            label="Brand Ownership"
            width="150"
          >
          <template slot-scope="scope">
            {{scope.row.brandOwnerShip?'Brand Owner':'Brand Agent'}}
          </template>
        </el-table-column>
        <el-table-column
            label="Create Time"
            prop="createTime"
            width="150"
          >
        </el-table-column>
        <el-table-column
            label="Supplier"
            prop="supplier"
          >
        </el-table-column>
        <el-table-column
            label="Reviewer / Review time"
            width="180"
          >
          <template slot-scope="scope">
            <div>{{scope.row.reviewer}}</div>
            <div>{{scope.row.reviewTime}}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="Preview link" width="130">
          <template slot-scope="scope">
            <span @click="openUrl(scope)" class="table-url">View</span>
          </template>
        </el-table-column>

      </el-table>
    </div>
    <pagination
       :currentPage="paging.current"
      :total="paging.total"
      :pageSize="paging.size"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    />
  </div>
</template>

<script>
import Pagination from '../components/pagination.vue'
import { getAction } from '@/api/manage.js'
import { handleClipboard } from '@/utils/copy'
import qs from 'qs'
import CustomBreadcrumb from '../components/custom-breadcrumb'
export default {
  name: 'brands',
  components: {CustomBreadcrumb, Pagination},
  data() {
    return {
      drop: {
        ownerShip: [
          {
            name: 'All',
            value: ''
          },
          {
            name: 'Brand Owner',
            value: 1
          },
          {
            name: 'Brand Agent',
            value: 0
          }
        ],
        shoppingFee: [
          {
            name: 'Free Shipping',
            value: 2
          },
          {
            name: ' non-Free',
            value: 1
          }
        ],
        status: [
          {
            name: ' Active',
            value: 1
          },
          {
            name: 'Inactive',
            value: 2
          }
        ]
      },
      brandsForm: {
        pageSize: 20,
        currentPage: 1
      },
      tableData: [],
      paging: {}
    }
  },
  async created() {
    this.search()
  },
  methods: {
    copy(e, val) {
      handleClipboard(val, e)
    },
    openUrl(obj) {
      let env = process.env.NODE_ENV
      let url = ''
      env === 'test' ? url = 'https://test-thalesmart-manage-ui2.hupofintech.com/brand'
        : url = 'https://www.shopvidi.com/brand'
      window.open(url + obj.row.seoUrl)
    },
    async search() {
      let table = await getAction(`/sp/suppliers/brand?${qs.stringify(this.brandsForm)}`)
      this.tableData = table.result.records
      this.paging = table.result
    },
    handleSizeChange(val) {
      this.brandsForm.pageSize = val
      this.brandsForm.currentPage = 1
      this.search()
    },
    handleCurrentChange(val) {
      this.brandsForm.currentPage = val
      this.search()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-input-group__append{
  background: #000000;
  color: #ffffff;
  :hover{
    cursor: pointer;
  }
}
/deep/.cell{
font-size: 14px;
font-family: Avenir;
font-weight: 500;
color: #000000;
}
.brands{
  .title{
    font-size: 14px;
    font-family: Graphik;
    font-weight: 600;
    color: #262B2F;
    margin: 10px 30px 20px 0px !important;
  }
  padding: 0px 30px 0 0px;
}
.copy-text{
  cursor: pointer;
}
.table-brand{
  display: flex;
  .table-brand-img{
    max-width: 80px;
    max-height: 80px;
    border: 1px solid #cccccc;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .table-brand-text{
    padding: 9px 0 0 8px;
  }
}
.table-url{
  cursor: pointer;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/pages/brands/index.vue